module.exports = __webpack_public_path__ + "71d1dd64988543b4a01b170d2c25dd6b.png";